import { request } from '../../Common/api/client';

/**
 * POST /api/admin/login (관리자 로그인)
 * @param {string} adminId
 * @param {string} password
 * @param {string} [otpToken] - 6자리 OTP (선택)
 * @returns {Promise<{ user: object, requireOtp: boolean, screen: string[] }>}
 */
export async function adminLogin(adminId, password, otpToken) {
  const body = { adminId, password };
  if (otpToken) body.otpToken = otpToken;
  return request({ method: 'POST', url: '/api/admin/login', data: body });
}

/**
 * POST /api/admin/logout (로그아웃)
 */
export async function adminLogout() {
  return request({ method: 'POST', url: '/api/admin/logout' });
}

/**
 * GET /api/admin/me (로그인 유효성 확인)
 */
export async function adminMe() {
  return request({ method: 'GET', url: '/api/admin/me' });
}

/**
 * POST /api/admin/change-password - 관리자 비밀번호 변경
 * Body: { currentPassword, newPassword }
 */
export async function adminChangePassword({ currentPassword, newPassword }) {
  return request({
    method: 'POST',
    url: '/api/admin/change-password',
    data: { currentPassword, newPassword },
  });
}

/**
 * POST /api/auth/admin/otp/verify (관리자 OTP 검증)
 * @param {string} token - 6자리 OTP
 * @param {string} [deviceId] - 선택
 */
export async function adminOtpVerify(token, deviceId) {
  const data = { token };
  if (deviceId) data.deviceId = deviceId;
  return request({ method: 'POST', url: '/api/auth/admin/otp/verify', data });
}
